var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "horizontal_rule_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#484848}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19898",
    "data-name": "Rectangle 19898",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21923",
    "data-name": "Group 21923",
    transform: "translate(3.333 4.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19899",
    "data-name": "Rectangle 19899",
    className: "cls-2",
    transform: "translate(0 5)",
    d: "M0 0h13.333v1.667H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19900",
    "data-name": "Rectangle 19900",
    className: "cls-2",
    transform: "translate(1.667 2.5)",
    d: "M0 0h10v.833H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19901",
    "data-name": "Rectangle 19901",
    className: "cls-2",
    transform: "translate(1.667)",
    d: "M0 0h10v.833H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19902",
    "data-name": "Rectangle 19902",
    className: "cls-2",
    transform: "translate(1.667 8.333)",
    d: "M0 0h10v.833H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19903",
    "data-name": "Rectangle 19903",
    className: "cls-2",
    transform: "translate(1.667 10.833)",
    d: "M0 0h10v.833H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLine);
export default __webpack_public_path__ + "static/media/horizontal-line.593914f44d40d51d3559d69e059f3d17.svg";
export { ForwardRef as ReactComponent };